<template>
  <v-container fluid style="height: 100%;" class="pb-0">
    <v-overlay
      :value="overlay"
      absolute
      opacity="0.7"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Eventos...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog
      v-model="restrictedPeopleModal"
      max-width="800"
      persistent>

      <v-card>
        <div class="d-flex justify-end" style="background-color: #31394C">
          <v-btn class="mt-1 mr-1" icon small @click="restrictedPeopleModal = !restrictedPeopleModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="d-flex justify-center pt-0">
          <span class="text-h6">Eventos por Gestionar</span>
        </v-card-title>
        <v-card-text>
          <v-row class="px-4">
            <v-col cols="12" class="py-0">
              <label>Filtro</label>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="10" class="d-flex justify-center align-center">
              <v-text-field
                v-model="documentNumberDeniedLabelText"
                label="Número Documento"
                outlined
                dark
                hide-details="auto"
                color="secondary"
                clear-icon="mdi-close-circle"
                clearable
                @click:clear="documentNumberDeniedLabelText = ''; getEntries(documentNumberDeniedLabelText)"
                :disabled="restrictedEventsGrouped && restrictedEventsGrouped.length > 0 ? false : true"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="d-flex justify-center align-center">
              <v-btn
                class="mx-1"
                rounded
                small
                color="secondary"
                dark
                :disabled="documentNumberDeniedLabelText ? false : true"
                @click="getRestrictedEvents(documentNumberDeniedLabelText)"
              >
                <i class="fal fa-search"></i>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-0 d-flex align-stretch" style="min-height: 370px; max-height: 390px; overflow: hidden; overflow-y: scroll;overflow-x: hidden;">
            <v-col class="px-1 d-flex justify-center" cols="12" md="3" v-for="(person, i) in restrictedEventsGrouped" :key="i">
              <v-card rounded="lg" class="d-flex flex-column justify-between" width="90%" max-height="230px" style="background-color: #3C465D !important;" :style="person.events[0].name !== 'N undefined' ? 'cursor: pointer' : 'cursor: not-allowed'" :class="'border-' + person.events[0].type_event">
                <div class="pa-0 ma-0 d-flex justify-center" @click="person.events[0].name !== 'N undefined' ? getKnownData(person.events) : null">
                  <v-img :src="getVisionidUrlPic(person.events[0].img_id, 'face_')" max-width="60px" class="text-center">
                  </v-img>
                </div>
                <div class="text-center" style="font-size: x-small">
                  <p>{{ person.events[0].name }}</p>
                  <p>F: {{ person.events[0].created_time.substring(0, 10) }}</p>
                  <p>H: {{ person.events[0].created_time.substring(11, 19) }}</p>
                  <p class="px-1">C: {{ getCamName(person.events[0].slave) ? getCamName(person.events[0].slave) : "N/A" }}</p>
                  <p class="px-1">L: {{ getZoneName(person.events[0].asset) ? getZoneName(person.events[0].asset) : "N/A"}}</p>
                  <div v-if="activateFastRegistry" class="d-flex justify-center align-center my-1">
                    <p class="pt-1">CheckIn rápido</p>
                    <v-checkbox
                      class="my-0"
                      color="white"
                      hide-details
                      dense
                      @change="quickRegister(person.events[0], $event)"
                    ></v-checkbox>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-dialog>

    <v-dialog
      v-model="askSecureRegistryModal"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-text>
          <div class="text-h6 pt-3 text-center">Se enviará a Check In {{ quickRegisterEvents.length }} persona{{ quickRegisterEvents.length == 1 ? '' : 's' }}</div>
          <div class="text-h6 text-center">¿Desea proceder con el envio?</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            color="success"
            @click="enviarOneID"
          >Si, proceder</v-btn>
          <v-btn
            text
            color="error"
            @click="askSecureRegistryModal = !askSecureRegistryModal"
          >Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="knownModal">
      <v-dialog v-model="knownModal" content-class="modalVs" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="text-h6">Información Usuario {{ restrictedPeopleModal === true ? 'por Gestionar' : ''}}</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="text-center">
                <p class="font-weight-light pb-2 secondary--text" style="font-size: 1.15rem">IMG. REGISTRO</p>
                <div class="avatarAcces2 d-flex justify-center">
                  <v-img
                    style="max-height: 150px; max-width: 250px"
                    :src="'https://devback2.vanguardtech.solutions/api/entry/registry-pic/' + selectedKnownUser.register_image"
                    lazy-src="../../assets/loading.png"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="black"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="text-center">Tipo Documento: {{ selectedKnownUser.document_type }} </div>
                <div class="text-center">Documento: {{ selectedKnownUser.document_number }}</div>
                <div class="text-center">Nombre: {{  selectedKnownUser.first_name + (selectedKnownUser.second_name ? " " + selectedKnownUser.second_name : "") + " " + selectedKnownUser.first_last_name + " " + (selectedKnownUser.second_last_name ? selectedKnownUser.second_last_name : "") }}</div>
                <div class="text-center">Grupo de Permisos: {{ selectedKnownUser.company_person.pin ? getPG(selectedKnownUser.company_person.pin) : "Sin Permisos" }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-layout child-flex>
                <v-data-table
                  :headers="headersKnown"
                  :items="selectedKnownUserEvents"
                  :items-per-page="10"
                  :header-props="{
                    mobile: true,
                  }"
                  :footer-props="{
                    'items-per-page-options': [10],
                  }"
                  fixed-header
                  no-data-text="No hay eventos que mostrar"
                >

                  <template v-slot:[`item.ImgAccess`]="{ item }">
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar
                          size="42"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'face_')"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </template>
                      <v-row class="pa-0">
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'frame_')"
                            max-width="100"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'body_')"
                            max-width="80"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'face_')"
                            max-width="60"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                      </v-row>
                      <!-- <v-img
                        :src="getVisionidUrlPic(item.img_id, 'face_')"
                        width="200"
                        lazy-src="../../assets/loading.png"
                        @error="'../../assets/loading.png'"
                      >
                       <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="black"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img> -->
                      
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.asset`]="{ item }">
                    <div>
                      {{ getZoneName(item.asset) }}
                    </div>
                  </template>
                  <template v-slot:[`item.slave`]="{ item }">
                    <div>
                      {{ getCamName(item.slave) }}
                    </div>
                  </template>
                  <template v-slot:[`item.type_event`]="{ item }">
                    <v-chip
                      class="small-chip ma-0"
                      :color="getColorEvent(item.type_event)"
                      text-color="white"
                      small
                    >
                      {{ item.type_event === 'granted' ? 'Permitido' : item.type_event === 'denied' ? 'Sin Asignar' : 'Lista Negra' }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.created_time`]="{ item }" >
                    {{
                      item.created_time.substring(0, 10)
                    }} - {{
                      item.created_time.substring(11, 19)
                    }}
                  </template>
                </v-data-table>
              </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="unknownModal">
      <v-dialog v-model="unknownModal" content-class="modalVs" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="text-h6">Información Desconocido</span>
          </v-card-title>

          <v-card-text>
            <!-- <v-row>
              <v-col v-if="entrySelected && entrySelected.access_type !== 'unrecognized' && entrySelected.access_type !== 'denied_by_company'" cols="12" md="6" class="text-center">
                <p class="font-weight-light pb-2 secondary--text" style="font-size: 1.15rem">IMG. REGISTRO</p>
                <div class="avatarAcces2">
                  <v-img
                    style="max-height: 250px; max-width: 600px"
                    :src="PSRegistryImg"
                    lazy-src="../assets/loading.png"
                    @error="imgErrorHandler"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="black"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </v-col>
              <v-col cols="12" :md="entrySelected && entrySelected.access_type !== 'unrecognized' && entrySelected.access_type !== 'denied_by_company' ? 6 : 12" class="text-center">
                <p v-if="lunchModule" class="font-weight-light pb-2 secondary--text" style="font-size: 1.15rem">IMG. ÚLTIMA ENTREGA</p>
                <p v-if="!lunchModule" class="font-weight-light pb-2 secondary--text" style="font-size: 1.15rem">IMG. ÚLTIMO ACCESO</p>
                <div class="avatarAcces2">
                  <v-img
                    style="max-height: 250px; max-width: 600px"
                    :src="PSDailyImg"
                    lazy-src="../assets/loading.png"
                    @error="'../assets/loading.png'"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="black"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12">
                <v-layout child-flex>
                <v-data-table
                  :headers="headersUnknown"
                  :items="selectedUnknownUserEvents"
                  :items-per-page="10"
                  :header-props="{
                    mobile: true,
                  }"
                  :footer-props="{
                    'items-per-page-options': [10],
                  }"
                  fixed-header
                  no-data-text="No hay eventos que mostrar"
                >

                  <template v-slot:[`item.ImgAccess`]="{ item }">
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar
                          size="42"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'face_')"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </template>
                      <v-row class="pa-0">
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'frame_')"
                            max-width="100"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'body_')"
                            max-width="80"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                        <v-col cols="4" class="py-0 d-flex justify-center align-center">
                          <v-img
                            :src="getVisionidUrlPic(item.img_id, 'face_')"
                            max-width="60"
                            lazy-src="../../assets/loading.png"
                            @error="'../../assets/loading.png'"
                          >
                          <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="black"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-col>
                      </v-row>                      
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.asset`]="{ item }">
                    <div>
                      {{ getZoneName(item.asset) }}
                    </div>
                  </template>
                  <template v-slot:[`item.slave`]="{ item }">
                    <div>
                      {{ getCamName(item.slave) }}
                    </div>
                  </template>
                  <template v-slot:[`item.type_event`]>
                    <v-chip
                      class="small-chip ma-0"
                      color="error"
                      text-color="white"
                      small
                    >
                      DESCONOCIDO
                    </v-chip>
                  </template>
                  <template v-slot:[`item.created_time`]="{ item }" >
                    {{
                      item.created_time.substring(0, 10)
                    }} - {{
                      item.created_time.substring(11, 19)
                    }}
                  </template>
                </v-data-table>
              </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog
      v-model="bookingDialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card>
        <div align="right" class="pr-2 pt-1 ma-0" @click="bookingData = null; bookingDialog = !bookingDialog; idBookingHolder = ''" style="cursor: pointer">
          <v-icon
            class="text-center"
            color="white"
            size="25"
          >
            mdi-close-circle
          </v-icon>
        </div>
        <v-card-title class="d-flex justify-center pt-0">
          Gestionar Reserva
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col>
              <v-text-field
                v-model="idBookingHolder"
                label="# Documento Titular"
                :append-outer-icon="'mdi-send'"
                hide-details
                outlined
                dark
                dense
                color="secondary"
                @click:append-outer="searchBooking(idBookingHolder)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="bookingData">
            <v-col cols="12" class="text-center">
              <div>ID Reserva: {{ bookingData.booking_id.trim() }}</div>
              <div>ID Titular: {{ bookingData.doc_number.trim() }}</div>
              <div>Nombre Titular: {{ bookingData.holder_name.trim() }}</div>
              <div># Adultos: {{ bookingData.adults }}</div>
              <div># Niños: {{ bookingData.kids }}</div>
              <div>Habitación: {{ bookingData.room_name.trim() }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text
            color="secondary"
            :disabled="!bookingData || recognizedEvents.length === 0 || notRecognizedEvents.length === 0"
            @click="activateFastRegistry = true; bookingDialog = !bookingDialog">Seleccionar Huespedes</v-btn>
          <v-btn text
            color="success"
            :disabled="!bookingData"
            @click="sendOneIDNoBooking">Enviar Sin Huespedes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <div :style="activateFastRegistry === true ? 'display: grid; grid-template-columns: 50% 11% 17% 12% 10%;' : 'display: grid; grid-template-columns: 60% 15% 15% 10%;'">
          <h4 class="text-left ml-2">VISION ID</h4>
          
          <div class="d-flex justify-end align-center pr-2">
            <v-btn :disabled="restrictedEventsGrouped.length === 0" @click="restrictedPeopleModal = !restrictedPeopleModal" elevation="1" small color="blue-grey darken-1">Eventos por Gestionar</v-btn>
          </div>
          <div class="d-flex justify-end align-center pr-2">
            <!-- //TODO: Uncomment when the booking system is ready -->
            <!-- <v-btn v-if="(typePlace == 'luxe' || typePlace == 'charlee' || typePlace == 'thebrown' || typePlace == 'vanguard') &&  bookingData === null" @click="bookingDialog = !bookingDialog" elevation="1" small color="secondary">Buscar Reserva</v-btn> -->
            <v-btn v-if="(typePlace == 'loft' || typePlace == 'luxe' || typePlace == 'charlee' || typePlace == 'thebrown' || typePlace == 'vanguard')" @click="activateFastRegistry === true ? activateFastRegistry = false : activateFastRegistry = true" elevation="1" small :color="activateFastRegistry === true ? 'error' : 'success darken-2'">{{  activateFastRegistry === true ? 'Desactivar Fast CheckIn' : 'Activar Fast CheckIn'}}</v-btn>
            <v-chip
              v-if="bookingData && !bookingDialog"
              class="ma-2"
              close
              color="secondary"
              label
              outlined
              @click:close="bookingData = null; idBookingHolder = ''; activateFastRegistry = !activateFastRegistry; quickRegisterEvents = []"
            >
              Reserva: {{ bookingData.booking_id }}
            </v-chip>
          </div>
          <div v-if="activateFastRegistry === true" class="d-flex justify-center align-center pr-2">
            <v-btn :disabled="quickRegisterEvents.length === 0" @click="validateSendCheckInBtn" color="secondary" small>Enviar CheckIn</v-btn>
          </div>
          <div class="text-right py-1">
            <v-menu
              v-model="datepickerEvents"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filterDate"
                  label="Fecha Busqueda"
                  readonly
                  outlined
                  dark
                  color="secondary"
                  dense
                  hide-details="auto"
                  hide-hints
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterDate"
                @input="datepickerEvents = false"
                locale="es-MX"
                @change="overlay = true; recognizedEvents = []; notRecognizedEvents = []; getEntries(documentNumberLabelText)"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="pt-0" style="height: 60hv !important">
        <v-tabs height="30" style="width: 83%">
          <v-tab v-for="(camera, index) in camerasList" :key="index" class="px-1" @click="changeChannel(camera)"> <!-- @click="startStream(ipcam + camera.slaveID)"> -->
            {{ camera.name }}
          </v-tab>
        </v-tabs>
        <div>
          <!-- <div ref="videoContainer"></div> -->
          <!-- <img src="http://192.168.0.128:5000/video" alt="video" style="width: 100%; height: 100%; object-fit: contain;" /> -->
          <img :src="'http://' + camerasList[0].ip_device + ':5000/video'" alt="video" style="width: 100%; height: 100%; object-fit: contain;" />
        </div>
      </v-col>

      <v-col cols="12" md="6" class="py-0">
        <v-card style="height: 100% !important">
          <div class="pa-2 text-center">RECONOCIDOS
          </div>
          
          <v-row class="px-4">
            <v-col cols="12" class="py-0">
              <label class="text-right caption grey--text">{{ recognizedEvents.length > 0 ? recognizedEvents.length + " Personas Reconocidas": "" }}</label>
              <label>Filtro</label>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="10" class="d-flex justify-center align-center">
              <v-text-field
                v-model="documentNumberLabelText"
                label="Número Documento"
                outlined
                dark
                hide-details="auto"
                color="secondary"
                clear-icon="mdi-close-circle"
                clearable
                @click:clear="documentNumberLabelText = ''; getEntries(documentNumberLabelText)"
                :disabled="recognizedEvents && recognizedEvents.length > 0 ? false : true"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="d-flex justify-center align-center">
              <v-btn
                class="mx-1"
                rounded
                small
                color="secondary"
                dark
                :disabled="documentNumberLabelText ? false : true"
                @click="getEntries(documentNumberLabelText)"
              >
                <i class="fal fa-search"></i>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="recognizedEvents.length > 0" class="mx-0 d-flex align-stretch" style="min-height: 370px; max-height: 390px; overflow: hidden; overflow-y: scroll;overflow-x: hidden;">
            <v-col class="px-1 d-flex justify-center" cols="12" md="3" v-for="(person, i) in recognizedEvents" :key="i">
              <v-card rounded="lg" class="d-flex flex-column justify-between" width="90%" max-height="230px" style="background-color: #3C465D !important;" :class="'border-' + person.events[0].type_event">
                <div class="pa-0 ma-0 d-flex justify-center" @click="getKnownData(person.events)">
                  <v-img :src="getVisionidUrlPic(person.events[0].img_id, 'face_')" max-width="60px" class="text-center">
                    <!-- <div class="d-flex align-end" style="width: 100%; height: 100%;">
                      <v-img :src="getVisionidUrlPic(person.events[0].img_id, 'frame_')" max-width="60px" contain
                        lazy-src="https://cdn.wallpapersafari.com/38/20/PB9auk.png">
                      </v-img>
                    </div> -->
                  </v-img>
                </div>
                <div class="text-center" style="font-size: x-small">
                  <p class="my-1">{{ person.events[0].name }}</p>
                  <p class="mb-1">F: {{ person.events[0].created_time.substring(0, 10) }}</p>
                  <p class="mb-1">H: {{ person.events[0].created_time.substring(11, 19) }}</p>
                  <p class="mb-1 px-1">C: {{ getCamName(person.events[0].slave) ? getCamName(person.events[0].slave) : "N/A" }}</p>
                  <p class="mb-1 px-1">L: {{ getZoneName(person.events[0].asset) ? getZoneName(person.events[0].asset) : "N/A"}}</p>
                  <!-- <p class="mb-1 px-1">I: {{ person.events[0].img_id}}</p> -->
                  <!-- <p class="mb-1">{{ person.events[0].document_number }}</p>
                  <p class="mb-1">C: {{ getCamName(person.events[0].slave) ? getCamName(person.events[0].slave) : "N/A" }}</p>
                  <p class="mb-1">L: {{ getZoneName(person.events[0].asset) ? getZoneName(person.events[0].asset) : "N/A"}}</p>
                  <p class="mb-1">Detecciones Previas: {{ person.events.length - 1 }}</p> -->
                  <div v-if="activateFastRegistry" class="d-flex justify-center align-center my-1">
                    <p class="pt-1">CheckIn rápido</p>
                    <v-checkbox
                      class="my-0"
                      color="white"
                      hide-details
                      dense
                      @change="quickRegister(person.events[0], $event)"
                    ></v-checkbox>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <div class="text-center">
                <h5>No hay eventos que mostrar</h5>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-1 pb-0">
        <v-card>
          <div class="pa-2 text-center" @click="handleDivClick">NO RECONOCIDOS</div>
          <v-row class="mx-0" v-if="notRecognizedEvents.length > 0" style="max-height: 500px; overflow: hidden; overflow-y: scroll;overflow-x: hidden;">

            <v-col class="px-1 d-flex justify-center" cols="12" md="1" sm="6" v-for="(unknown, i) in notRecognizedEvents" :key="i">
              <v-card rounded="lg" class="d-flex flex-column justify-between" width="80%" style="border-bottom: 5px solid red; background-color: #3C465D !important;">
                <div class="pa-0 ma-0 d-flex justify-center" @click="selectedUnknownUserEvents = unknown.events ; knownModal = false ; unknownModal = true" >
                  <v-img :src="getVisionidUrlPic(unknown.events[0].img_id, 'face_')" max-width="60px" class="text-center">
                    <!-- <div class="d-flex align-end" style="width: 100%; height: 100%;">
                      <v-img :src="getVisionidUrlPic(unknown.events[0].img_id, 'frame_')" max-width="60px" contain
                        lazy-src="https://cdn.wallpapersafari.com/38/20/PB9auk.png">
                      </v-img>
                    </div> -->
                  </v-img>
                </div>
                <div class="text-center" style="font-size: x-small">
                  <p class="mt-2 mb-1">F: {{ unknown.events[0].created_time.substring(0, 10) }}</p>
                  <p class="mt-2 mb-1">H: {{ unknown.events[0].created_time.substring(11, 19) }}</p>
                  <p v-if="labelIsActivated" class="mt-2 mb-1">T: {{ unknown.events[0].type_event }}</p>
                  <!-- <p class="mt-2 mb-1">I: {{ unknown.events[0].img_id }}</p> -->
                  <p class="mb-1">C: {{ getCamName(unknown.events[0].slave) ? getCamName(unknown.events[0].slave) : "N/A" }}</p>
                  <p class="mb-1">L: {{ getZoneName(unknown.events[0].asset) ? getZoneName(unknown.events[0].asset) : "N/A"}}</p>
                  <!-- <p class="mb-1">Visitas Previas: {{ unknown.events.length - 1 }}</p> -->
                  <div v-if="activateFastRegistry" class="d-flex justify-center align-center my-1">
                    <p class="pt-1">CheckIn rápido</p>
                    <v-checkbox
                      class="my-0"
                      color="white"
                      hide-details
                      dense
                      @change="quickRegister(unknown.events[0], $event)"
                    ></v-checkbox>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <div class="text-center">
                <h5>No hay eventos que mostrar</h5>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" timeout="6000" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import globals from "../../globals";
import axios from "axios";
import auth from "../../services/auth";
//import backlog from "../services/logs";
import JSMpeg from 'jsmpeg-player';

export default {
  name: "GeneralDashboard",
  components: {
  },
  data() {
    return {
      urlVideo: "http://10.10.1.164:5000/video_feed",
      interval: null,
      datepickerEvents: false,
      filterDate: globals.COdate().substring(0, 10),
      typePlace: auth.getUserEnterpriseName(),
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      documentNumberLabelText: "",
      documentNumberDeniedLabelText: "",
      overlay: false,
      camerasList: [],
      recognizedEvents: [],
      notRecognizedEvents: [],
      devices: [],
      blList: [],
      permissionGroupsList: [],
      sedes: [],
      streamingUp: null,
      loadingStreaming: false,
      quickRegisterEvents: [],
      registry: [],
      activateFastRegistry: false,
      askSecureRegistryModal: false,
      knownModal: false,
      unknownModal: false,
      bookingDialog: false,
      headersKnown: [
        { text: "Imgs.", sortable: false, align: "center", value: "ImgAccess" },/* 
        { text: "N. Doc", sortable: false, align: "center", value: "document_number" },
        { text: "Nombre", sortable: false, align: "center", value: "name" }, */
        { text: "Zona", sortable: false, align: "center", value: "asset" },
        { text: "Cam", sortable: false, align: "center", value: "slave" },
        { text: "Tipo", sortable: true, align: "center", value: "type_event" },
        { text: "Fecha - Hora", sortable: true, align: "center", value: "created_time" },
      ],
      headersUnknown: [
        { text: "Imgs.", sortable: false, align: "center", value: "ImgAccess" },
        { text: "Zona", sortable: false, align: "center", value: "asset" },
        { text: "Cam", sortable: false, align: "center", value: "slave" },
        { text: "Tipo", sortable: false, align: "center", value: "type_event" },
        { text: "Fecha - Hora", sortable: true, align: "center", value: "created_time" },
      ],
      selectedKnownUserEvents: [],
      selectedUnknownUserEvents: [],
      selectedKnownUser: null,
      idBookingHolder: null,
      bookingData: null,
      ipcam: /* //"rtsp://10.10.2.166:8554/", //"rtsp://10.10.2.92:8554/", */ "rtsp://192.168.86.41:8554/",
      restrictedPeopleModal: false,
      restrictedEventsGrouped: [],
      individualRestrictedEvents: null,
      clickCount: 0,
      labeIsActivated: false,
    };
  },
  methods: {
    handleDivClick() {
      this.clickCount++;
      if (this.clickCount === 4) {
        this.labelIsActivated = !this.labelIsActivated;
        this.clickCount = 0; // Reset counter after activation
      }
    },

    getColorEvent(type) {
      if (type === "granted") {
        return "green";
      } else {
        if (type === "denied") {
          return "blue-grey";
        } else {
          return "black";
        }
      }
    },

    searchBooking(idBookingHolder) {
      if (idBookingHolder) {
        axios({
          method: "GET",
          baseURL: "https://172.16.30.226:3000/data-query/person/" + idBookingHolder
        }).then((res) => {
          if (res.status === 200 && res.data.length > 0) {
            //console.log("BookingData: ", res.data)
            this.bookingData = res.data[0]
          } else {
            this.snackbar = true;
            this.snackbarColor = "error";
            this.snackbarText = "No hay reservas asignadas a esta persona."
          }
        }).catch((err) => {
          console.log(err)
        });
      }
    },

    validateSendCheckInBtn() {
      //TODO: Uncomment when the booking system is ready
      /* if (this.quickRegisterEvents.length > this.bookingData.adults + this.bookingData.kids) {
        this.snackbar = true;
        this.snackbarColor = "error"
        this.snackbarText = "Está seleccionando mas huespedes de la cantidad permitida por la reserva"
      } else {
        this.askSecureRegistryModal = !this.askSecureRegistryModal
      } */
     this.askSecureRegistryModal = !this.askSecureRegistryModal
    },

    getPG(id) {
      let pg = this.permissionGroupsList.find(x => x.uuid === id)
      return pg ? pg.name : "Sin Permisos Asignados"
    },

    getCamName(id) {
      let cam = this.camerasList.find(x => x.slaveID === id)
      return cam ? cam.name : ""
    },

    getZoneName(id) {
      let zone = this.sedes.find(x => x.uuid === id)
      return zone ? zone.name : ""
    },

    sendOneIDNoBooking() {
      let url = "https://oneid.ai/Welcome?guests=[]";

      if (this.bookingData) {
        url = url + "&booking=" + JSON.stringify(this.bookingData);
      }

      this.bookingData = null
      this.idBookingHolder = ""
      this.bookingDialog = !this.bookingDialog
      window.open(url, "_blank");
    },

    enviarOneID() {
      const esta = this.quickRegisterEvents;
      let dataToSend = []

      esta.map((event) => {
        if (event.type_event === 'granted' || event.type_event === 'denied' || event.type_event === 'black_list') {
          let esto = this.registry.find(x => x.uuid === event.person_id);
          console.log(esto)
          dataToSend.push({
            "user_id": esto.uuid,
            "names": [esto.first_name, esto.second_name ? esto.second_name : ""],
            "last_names": [esto.first_last_name, esto.second_last_name ? esto.second_last_name : ""],
            //"images_ID": "",
            "register_image": esto.register_image, 
            "doc_type": esto.document_type,
            "doc_number": esto.document_number,
            "reference_image": event.img_id,
            //"expiration_date": "",
            "expedition_date": esto.expedition_date,
            "birthdate": esto.birthdate,
            "email": esto.email,
            "phone": esto.phone,
            type: "registered"
          })
        } else {
          if (event.type_event === 'unknown_by_company') {
            dataToSend.push({
              "user_id": event.person_id,
              /* "names": ["", ""],
              "last_names": ["", ""],
              "images_ID": "",
              "selfie_key": "",
              "doc_type": "",
              "doc_number": "",
              "expiration_date": "",
              "email": "",
              "phone": "", */
              "reference_image": event.img_id,
              "type": "unknown_by_company"
            })
          } else if (event.type_event === 'no_register_nn') {
            dataToSend.push({
              /* "user_id": "",
              "names": ["", ""],
              "last_names": ["", ""],
              "images_ID": "",
              "selfie_key": "",
              "doc_type": "",
              "doc_number": "",
              "expiration_date": "",
              "email": "",
              "phone": "", */
              "reference_image": event.img_id,
              "type": "NN"
            })
          } else {
            dataToSend.push({
              "user_id": event.person_id,
              /* "names": ["", ""],
              "last_names": ["", ""],
              "images_ID": "",
              "selfie_key": "",
              "doc_type": "",
              "doc_number": "",
              "expiration_date": "",
              "email": "",
              "phone": "", */
              "reference_image": event.img_id,
              "type": "kNN"
            })
          }
        }
      });
      //console.log(dataToSend)

      let url = "https://oneid.ai/Welcome?guests=" + JSON.stringify(dataToSend);

      if (this.bookingData) {
        url = url + "&booking=" + JSON.stringify(this.bookingData);
      }
      this.bookingData = null; 
      this.idBookingHolder = ''; 
      this.activateFastRegistry = !this.activateFastRegistry; 
      this.quickRegisterEvents = []
      this.askSecureRegistryModal = !this.askSecureRegistryModal;
      window.open(url, "_blank");
    },

    quickRegister(person, event) {
      //let maxSelector
      let findIndex = this.quickRegisterEvents.findIndex(x => x.person_id === person.person_id)
      /* if (this.bookingData) {
        maxSelector = this.bookingData.adults + this.bookingData.kids
      } */

      if (event) {
        if (findIndex === -1) {
          this.quickRegisterEvents.push(person)
        }
        /* if (this.quickRegisterEvents.length <= maxSelector) {
          if (findIndex === -1) {
            this.quickRegisterEvents.push(person)
          }
        } */
      } else {
        if (findIndex !== -1) {
          this.quickRegisterEvents.splice(findIndex, 1)
        }
      }

      console.log(this.quickRegisterEvents)
    },

    /* quickRegister(person, event) {
      let findIndex = this.quickRegisterEvents.findIndex(x => x.person_id === person.person_id)

      if (event) {
        if (this.quickRegisterEvents.length < 6) {
          if (findIndex === -1) {
            this.quickRegisterEvents.push(person)
          }
        }
      } else {
        if (findIndex !== -1) {
          this.quickRegisterEvents.splice(findIndex, 1)
        }
      }
    }, */

    getKnownData(events) {
      this.selectedKnownUser = null
      this.selectedKnownUserEvents = events;
      this.selectedKnownUser = this.registry.find(x => x.uuid === events[0].person_id);
      console.log(this.selectedKnownUser)
      if (this.selectedKnownUser) {
        this.knownModal = true;
        this.unknownModal = false;
      }
    },

    getVisionidUrlPic(img_id, type) {
      return type = globals.APIURL + "entry/get-pic-visionid/" + type + img_id + ".jpg";
    },

    getPremissionGroups() {
      axios({
        method: "GET",
        baseURL: globals.APIURL + "permission-group/get-pg/" + auth.get_asset_id(),
      }).then((data) => {
        if (data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];

            if (element.type_group == 'black_list') {
              this.blList.push(element)
              data.data.splice(i, 1)
            }
          }
          this.permissionGroupsList = data.data
        }
      }).catch((err) => {
        console.log(err)
      });
    },

    getRegistry() {
      axios
      .post(globals.APIURL + "registry/all", {
        company_id: auth.getUserEnterpriseID()
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          console.log(res.data)
          this.registry = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    getEntries(dni) {
      axios({
        method: "POST",
        url: globals.APIURL + "entry/grouped-entries-visionid",
        data: {
          start_date: this.filterDate + "T00:00:00.000Z",
          finish_date: this.filterDate + "T23:59:59.000Z",
          limit: 20000,
          type: "known",
          document_number: dni ? dni : null,
          ids: auth.getGZ().zones
        },
      })
      .then((res) => {
        if (res.data && res.data.length > 0 && res.data != 'No documents were found') {
          const groupedData = res.data.reduce((acc, item) => {
            const personId = item.person_id;

            // Find the group for the current person_id or create a new one
            let group = acc.find(group => group.person_id === personId);
            if (!group) {
              group = { person_id: personId, events: [] };
              acc.push(group);
            }

            // Add the item to the group
            group.events.push(item);

            return acc;
          }, []);

          this.recognizedEvents = groupedData;
          this.overlay = false;
        }
        this.overlay = false;
      })
      .catch((err) => {
        console.log(err)
        this.overlay = false;
      });
    },

    getRestrictedEvents(dni) {
      axios({
        method: "POST",
        url: globals.APIURL + "entry/restricted-events-visionid",
        data: {
          start_date: globals.COdate().substring(0, 10) + "T00:00:00.000Z",
          finish_date: globals.COdate().substring(0, 10) + "T23:59:59.000Z",
          limit: 20000,
          ids: auth.getGZ().zones,
          document_number: dni ? dni : null,
        },
      })
      .then((res) => {
        if (res.data && res.data.length > 0 && res.data != 'No documents were found') {
          const groupedData = res.data.reduce((acc, item) => {
            const personId = item.person_id;

            // Find the group for the current person_id or create a new one
            let group = acc.find(group => group.person_id === personId);
            if (!group) {
              group = { person_id: personId, events: [] };
              acc.push(group);
            }

            // Add the item to the group
            group.events.push(item);

            return acc;
          }, []);

          if (res.data.length > this.individualRestrictedEvents && this.restrictedPeopleModal === false) {
            this.restrictedPeopleModal = true;
          }
          this.restrictedEventsGrouped = groupedData;
          this.individualRestrictedEvents = res.data.length;
        }
      })
      .catch((err) => {
        console.log(err)
      });
    },

    getUnknownEntries() {
      axios({
        method: "POST",
        url: globals.APIURL + "entry/grouped-entries-visionid",
        data: {
          start_date: this.filterDate + "T00:00:00.000Z",
          finish_date: this.filterDate + "T23:59:59.000Z",
          limit: 20000,
          type: "unknown",
          ids: auth.getGZ().zones
        },
      })
      .then((res) => {
        if (res.data && res.data.length > 0 && res.data != 'No documents were found') {
          const groupedData = res.data.reduce((acc, item) => {
            const personId = item.person_id;

            // Find the group for the current person_id or create a new one
            let group = acc.find(group => group.person_id === personId);
            if (!group) {
              group = { person_id: personId, events: [] };
              acc.push(group);
            }

            // Add the item to the group
            group.events.push(item);

            return acc;
          }, []);

          this.notRecognizedEvents = groupedData;
          this.overlay = false;
        }
        this.overlay = false;
      })
      .catch((err) => {
        console.log(err)
        this.overlay = false;
      });
    },

    /* getDevices() {
      axios
        .post(globals.APIURL + "device/get-devices-grouped", {
          ids: auth.getGZ().zones
        })
        .then(data =>{ 
          if (data.data.length > 0) {
            this.devices = data.data
            this.getRegistry();
            this.getEntries();
            this.getUnknownEntries();
          } else {
            //this.getRegistry();
            this.getEntries();
            this.getUnknownEntries();
          }
        })
        .catch(err => {
          //this.getRegistry();
          this.getEntries();
          this.getUnknownEntries();
          console.log(err);
        })
    }, */

    getSedes() {
      this.sedes = []
      axios
        .post(globals.APIURL + "org/fo", {
          company_id: auth.getUserEnterpriseID(),
        })
        .then((res) => {
          if (res.data && res.data.Campus.length > 0) {
            this.sedes = res.data.Campus;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDevices() {
      axios({
        method: "POST",
        baseURL: globals.APIURL + "device/get-devices",
        data: {
          company_id: auth.getUserEnterpriseID(),
          type: "visionid"
        },
      }).then((res) => {
        if (res.data.length > 0) {
          this.getCameras(res.data.map(obj => obj.mac))
          this.getRegistry();
          this.getEntries();
          this.getUnknownEntries();
          this.getRestrictedEvents()
        }
      }).catch((err) => {
        console.log(err)
      });
    },

    getCameras(devices) {
      axios({
        method: "POST",
        baseURL: globals.APIURL + "device/get-slave-cameras",
        data: {
          devices: devices,
        },
      }).then((res) => {
        if (res.data.length > 0) {
          this.camerasList = res.data
          //this.camerasList[0].rtspExample = this.ipcam + this.camerasList[0].slaveID//"rtsp://192.168.1.20:8554/" + this.camerasList[0].slaveID
          //this.startStream(this.camerasList[0].rtspExample)
          this.changeChannel(this.camerasList[0], true)
        }
      }).catch((err) => {
        console.log(err)
      });
    },

    checkStreamingConnection() {
      this.streamingUp = true
      this.loadingStreaming = true;
      /*this.loadingStreaming = true;
      axios({
        method: "GET",
        baseURL: "http://10.10.1.164:5000/video_feed",
        timeout: 6000,
      }).then((data) => {
        this.loadingStreaming = false;
        console.log("GOO!", data);
      }).catch(() => {
        this.loadingStreaming = false;
        this.streamingUp = false;
      }); */
    },

    getEvery() {
      this.interval = setInterval(() => {
        this.getEntries(this.documentNumberLabelText);
        this.getUnknownEntries();
        this.getRestrictedEvents(this.documentNumberDeniedLabelText);
      }, 10000);
    },

    startStream(url) {
      const canvas = document.createElement('canvas');
      this.$refs.videoContainer.innerHTML = ''; // Clear previous canvas
      this.$refs.videoContainer.appendChild(canvas);

      const options = {
        canvas: canvas, // The created canvas element
        autoplay: true,
        audio: false,
      };

      if (this.player) {
        this.player.destroy();
      }
      console.log(url)
      //this.player = new JSMpeg.Player('ws://localhost:9999/stream?rtsp=' + url, options);
      this.player = new JSMpeg.Player('ws://localhost:9999', options);
    },

    changeChannel(camera, firstLoad) {
      axios({
        method: "POST",
        baseURL: globals.APIURL + "device/change-channel",
        data: {
          device_id: camera.deviceID,
          cam_id: camera.slaveID
        },
      }).then(() => {
        if (!firstLoad) {
          this.snackbar = true;
          this.snackbarColor = "success";
          this.snackbarText = "Canal cambiado!"
        }
      }).catch((err) => {
        console.log("ERR: ", err)
      })
    }
  },
  mounted() {
    this.getSedes()
    this.getPremissionGroups()
    this.getDevices()
    this.getEvery()
    this.checkStreamingConnection();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    if (this.player) {
      this.player.destroy();
    }
  },
};
</script>

<style>
canvas {
  width: 100%;
  height: auto;
}

.h0 {
  height: 100%;
}

.border-granted {
  border-bottom: 4px solid green !important;
}

.border-bl {
  border-bottom: 4px solid black !important;
}

.border-denied {
  border-bottom: 4px solid #617984 !important;
}
</style>